import InfoIconContainer from './InfoIconContainer';
import InfoIconUI from './InfoIconUI';
var InfoIcon = {
    Container: InfoIconContainer,
    UI: InfoIconUI
};
export default InfoIcon;
